"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Tue Jul 17 2018
 */

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * The purpose of promo identification is to designate such competitors’ prices as promotional.
 * The input data are all competitors’ prices of products that are often not known to be regular or promo prices.
 * @author RV
 */


var PromoPriceDetectionSettings =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(PromoPriceDetectionSettings, _DomainObject_1$Domai);

  /**
   * Constructs PromoPriceDetectionSettings instance.
   *
   * @param minPriceDecrease minimal price decrease over time means when price is min x % lower then previous price
   * @param minPriceIncrease maximal price increase over time means when price is min x % higher then previous price
   * @param minPriceLength minimal duration of the price (x-weeks) to identify promo prices
   * @param maxPriceLength maximal duration (x-weeks) to identify promo prices
   * @param promoLimit If it is detected more than x % promo prices, then display the alert to user and tag all
   * these prices as regular. User can set the thresholds/limit x % for promo (“promo limit”).
   */
  function PromoPriceDetectionSettings(minPriceDecrease, minPriceIncrease, minPriceLength, maxPriceLength, promoLimit) {
    var _this;

    _classCallCheck(this, PromoPriceDetectionSettings);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PromoPriceDetectionSettings).call(this));
    _this.minPriceDecrease = minPriceDecrease;
    _this.minPriceIncrease = minPriceIncrease;
    _this.minPriceLength = minPriceLength;
    _this.maxPriceLength = maxPriceLength;
    _this.promoLimit = promoLimit;
    return _this;
  }

  return PromoPriceDetectionSettings;
}(DomainObject_1.DomainObject);

exports.PromoPriceDetectionSettings = PromoPriceDetectionSettings; // tslint:disable-next-line:member-ordering

PromoPriceDetectionSettings.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(PromoPriceDetectionSettings.name);
  return {
    minPriceDecrease: builder.num('minPriceDecrease'),
    minPriceIncrease: builder.num('minPriceIncrease'),
    minPriceLength: builder.num('minPriceLength'),
    maxPriceLength: builder.num('maxPriceLength'),
    promoLimit: builder.num('promoLimit')
  };
}();